// Centralizes the build-time gate for the `?devmode=true` MSAL bypass.
// Mirrors the user app's src/utils/devModeEnabled.ts.
//
// import.meta.env.DEV alone is true only under `vite dev` (and vitest). The
// deployed DEV admin SWA is a Vite production build, so import.meta.env.DEV
// is false there — VITE_ALLOW_DEVMODE is set to 'true' in the DEV SWA build
// workflow (.github/workflows/swa-admin-dev.yml) so the devmode bypass stays
// available for live E2E. It is NOT set in the prod workflow, so prod builds
// strip the bypass entirely — ?devmode=true is inert there.

export function isDevModeAllowed(): boolean {
  return import.meta.env.DEV || import.meta.env.VITE_ALLOW_DEVMODE === 'true';
}

/**
 * Runtime companion to isDevModeAllowed() — true only when the build-time
 * gate passes AND devmode was actually activated for this session
 * (`?devmode=true` or the `admin.devmode` sessionStorage flag App.tsx's
 * useDevMode() persists on first load). Mirrors that same read without the
 * persistence side effect (App.tsx already owns writing the flag).
 *
 * Used to gate the useAdminOrchestratorHub.ts test seam (window.__adminHubTestEmit)
 * so it is both stripped from prod builds and inert in dev/DEV-SWA builds
 * unless a session opted into devmode.
 */
export function isDevModeActive(): boolean {
  if (!isDevModeAllowed()) return false;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('devmode') === 'true') return true;
    return sessionStorage.getItem('admin.devmode') === 'true';
  } catch {
    return false;
  }
}
